export const EntityPropValueCellRenderer = ({ value }) => {
  if (!value) return <span />

  let valueStr = value.toString();
  return <span>{valueStr}</span>
}